import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import { AdminVolumetryApiService } from '@apps/back/api/admin-volumetry-api.service';
import { AdminVolumetryWidgetApi, EntityVolumetryApi } from '@apps/back/api/models/admin-volumetry-api';
import { AdminVolumetryWidget, EntityVolumetry } from './bckp.state';
import * as fromBckpActions from './bckp.actions';

@Injectable()
export class BackBckpEffects {
    constructor(
        private actions: Actions,
        private adminVolumetryApi: AdminVolumetryApiService
    ) { }

    backBckpWidgetRequested = createEffect(() =>
        this.actions.pipe(
            ofType(fromBckpActions.BackBckpWidgetRequested),
            switchMap(({ offset }) =>
                this.adminVolumetryApi.getVolumetryWidget(offset)
                    .pipe(
                        map((api: AdminVolumetryWidgetApi) => {
                            const widget: AdminVolumetryWidget = {
                                currentTbytes: api.currentTbytes,
                                previousTbytes: api.previousTbytes,
                                variationPct: api.variationPct,
                                entityCount: api.entityCount,
                                since: api.since,
                                until: api.until,
                                periodLabel: api.periodLabel
                            };
                            return fromBckpActions.BackBckpWidgetSucceeded({ widget });
                        }),
                        catchError(() => of(fromBckpActions.BackBckpWidgetFailed()))
                    )
            )
        )
    );

    backBckpDetailRequested = createEffect(() =>
        this.actions.pipe(
            ofType(fromBckpActions.BackBckpDetailRequested),
            switchMap(({ months }: { months: number }) =>
                this.adminVolumetryApi.getVolumetryDetail(months)
                    .pipe(
                        map((apiEntities: EntityVolumetryApi[]) => {
                            // Collect all month keys and sort descending
                            const monthSet = new Set<string>();
                            const entities: EntityVolumetry[] = apiEntities.map((e: EntityVolumetryApi) => {
                                const monthly = e.monthly ?? {};
                                Object.keys(monthly).forEach(k => monthSet.add(k));
                                const total = Object.values(monthly).reduce((s, v) => s + v, 0);
                                return {
                                    entityId: e.entityId,
                                    entityName: e.entityName,
                                    monthly,
                                    total
                                };
                            });

                            const sortedMonths = Array.from(monthSet).sort((a, b) => b.localeCompare(a));

                            return fromBckpActions.BackBckpDetailSucceeded({ entities, months: sortedMonths });
                        }),
                        catchError(() => of(fromBckpActions.BackBckpDetailFailed()))
                    )
            )
        )
    );
}
